import './app';
import 'bootstrap/js/dist/modal';
const initializeMain = function() {
	/**
	 * Initialize all scripts
	 */
	$( function() {
		if ( $( 'body' ).hasClass( 'wp-admin' ) || $( 'body' ).hasClass( 'editor-styles-wrapper' ) ) {
			window.app.admin();
		} else {
			window.app.front();
		}
	} );

	window.addEventListener( 'resize', function() {
		this.setTimeout( () => {
			window.app.main.resizeDependent();
		}, 500 );
	} );


	( function( $ ) {
		let initializeBlock = function() {
			const $scrollContent = $( '.main-menu__inner' ).find( '.scroll-content' );
			let currentMaxHeight = $scrollContent.css( 'max-height' );
			if ( currentMaxHeight ) {
				currentMaxHeight = parseFloat( currentMaxHeight );
			}
			$scrollContent.css( 'max-height', `${currentMaxHeight + 1}px` );
		};

		// Initialize each block on page load (front end).
		$( document ).ready( function() {
			initializeBlock( $( this ) );
			window.addEventListener( 'resize', function() {
				initializeBlock( $( this ) );
			} );
		} );
	} )( jQuery );
};

initializeMain();
